export enum EvaluationPeriodEnum {
  EvaluationPeriodInfo,
  EvaluationPeriodKey,
}
